/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import { tasksControllerBulkDelete } from "./tasksControllerBulkDelete";
import { tasksControllerBulkUpdate } from "./tasksControllerBulkUpdate";
import { tasksControllerCreate } from "./tasksControllerCreate";
import { tasksControllerFindActivities } from "./tasksControllerFindActivities";
import { tasksControllerFindAll } from "./tasksControllerFindAll";
import { tasksControllerFindOne } from "./tasksControllerFindOne";
import { tasksControllerRemove } from "./tasksControllerRemove";
import { tasksControllerUpdate } from "./tasksControllerUpdate";

export function tasksService() {
  return { tasksControllerCreate, tasksControllerFindAll, tasksControllerBulkUpdate, tasksControllerFindActivities, tasksControllerFindOne, tasksControllerUpdate, tasksControllerRemove, tasksControllerBulkDelete }
}